import { apiFetch } from "./fetchApi";

export const fetchManager = async (companyId, BeURL, showAlert, setManagerIds) => {
    try {


        // 2️⃣ Send companyId as param for get manager Ids creation
        const accountRes = await apiFetch(`${BeURL}/manager-data/${companyId}`, {
            method: "GET",
        });

        const accountData = await accountRes.json();
        if (!accountData.success) {
            showAlert(accountData.message);
            return;
        }

        setManagerIds(accountData.manager)


    } catch (err) {
        console.error("Error in Fetch Manager:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }

}